import campaignConfig from '../../../../campaign-config/campaign.json';
import homeCardBackground from '../../../../assets/images/home-card-background-white.png';
import tutorHomeCardBackground from '../../../../assets/images/tutor-home-card-background.png';

export const globalColors = campaignConfig.global?.colors || {};
export const globalBackgrounds = campaignConfig.global?.backgrounds || {};
export const globalText = campaignConfig.global?.text || {};

const localTutorHomeAssets = {
	'src/assets/images/home-card-background-white.png': homeCardBackground,
	'src/assets/images/tutor-home-card-background.png': tutorHomeCardBackground,
};

export const tutorHomeConfig = campaignConfig.tutor_home || {};

export const resolveTutorHomeAsset = (asset) =>
	localTutorHomeAssets[asset] || asset;